<template>
  <div
    v-for="row in rows.filter((row) => row.condition !== false)"
    :key="row.label"
    class="grid-x align-justify"
    :class="[row.config?.class, returnResolution !== RETURN_RESOLUTIONS.REPLACEMENT && 'margin-top-xxs']"
    :aria-label="row.value ? `${row.label} ${row.value}` : row.label"
  >
    <span :class="row.config?.labelClass" aria-hidden="true" v-text="row.label"></span>
    <span :class="row.config?.valueClass" aria-hidden="true" v-text="row.value"></span>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { formatPrice } from '@/utils/returns/General';
import { RMA_DETAIL, RETURN_RESOLUTIONS } from 'config';

const props = defineProps({
  summary: {
    type: Object,
    default: () => {},
  },
  returnResolution: {
    type: String,
    default: '',
  },
  ssreSubmission: {
    type: Boolean,
    default: false,
  },
});
const rows = computed(() => [
  {
    label: RMA_DETAIL.SSRE.RETURNING_TITLE,
    condition: !props.ssreSubmission,
    config: {
      class: 'border-top padding-top-xs',
      labelClass: 'h5',
    },
  },
  {
    label: 'Subtotal',
    condition: !props.ssreSubmission,
    value: formatPrice(props.summary.subtotal),
  },
  {
    label: 'CA embedded battery fee',
    value: formatPrice(props.summary.batteryFee),
    condition: !props.ssreSubmission && props.summary.batteryFee,
  },
  {
    label: 'Tax',
    condition: !props.ssreSubmission,
    value: formatPrice(props.summary.tax),
  },
  {
    label: 'Total',
    condition: !!props.summary.total,
    value: formatPrice(props.summary.total),
  },
  {
    label: RMA_DETAIL.SSRE.RECEIVING_TITLE,
    condition: !!props.summary.receiving,
    config: {
      class: 'border-top margin-top-xs padding-top-xs',
      labelClass: 'h5',
    },
  },
  {
    label: 'Subtotal',
    value: formatPrice(props.summary.receiving?.subtotal),
    condition: !!props.summary.receiving,
  },
  {
    label: 'Tax',
    value: formatPrice(props.summary.receiving?.tax),
    condition: !!props.summary.receiving,
  },
  {
    label: 'Total',
    value: formatPrice(props.summary.receiving?.total),
    condition: !!props.summary.receiving,
  },
  {
    label: 'Exchange credit',
    value: formatPrice(props.summary.receiving?.credit),
    condition: !!props.summary.receiving,
    config: {
      class: 'border-top margin-top-m padding-top-m',
      valueClass: 'heavy',
    },
  },
  {
    label: props.summary?.amountDue !== undefined ? 'Amount Due' : 'Estimated Total Refund',
    condition: !props.ssreSubmission,
    value: formatPrice(props.summary?.amountDue !== undefined ? props.summary.amountDue : props.summary.estimatedTotalRefund),
    config: {
      class: 'border-top padding-top-m margin-top-m',
      labelClass: 'h6',
      valueClass: 'h4',
    },
  },
  {
    label: 'Estimated Amount Due',
    value: formatPrice(props.summary.amountDue || 0),
    condition: props.ssreSubmission,
    config: {
      labelClass: 'h6',
      valueClass: 'h4',
    },
  },
]);
</script>
